/**
 * Shared dark-glass surface for admin Dialog / AlertDialog content.
 * Radix portals mount under `document.body`, outside `.admin-app-shell` /
 * `.dark` wrappers — so we cannot rely on CSS variables alone (they resolve
 * to light `:root` tokens and look broken on membership modals).
 */

import { cn } from "@/lib/utils";

/** Surface + type for dialog panels (DialogContent / AlertDialogContent). */
export const ADMIN_DIALOG_CONTENT_CLASS = cn(
  "border border-white/[0.08] bg-zinc-950 text-zinc-100",
  "shadow-2xl shadow-black/70",
  "sm:rounded-xl",
  // Inputs / textareas inside admin modals
  "[&_input]:border-white/10 [&_input]:bg-white/[0.04] [&_input]:text-zinc-100",
  "[&_input]:placeholder:text-zinc-500",
  "[&_textarea]:border-white/10 [&_textarea]:bg-white/[0.04] [&_textarea]:text-zinc-100",
  "[&_textarea]:placeholder:text-zinc-500",
  "[&_label]:text-zinc-400",
);

export const ADMIN_DIALOG_TITLE_CLASS = "text-zinc-50 tracking-tight";
export const ADMIN_DIALOG_DESCRIPTION_CLASS = "text-zinc-400";

/** Destructive confirm primary (suspend / revoke). */
export const ADMIN_ALERT_DESTRUCTIVE_ACTION_CLASS =
  "bg-rose-600 text-white hover:bg-rose-500 focus:ring-rose-500/40";

/** Neutral outline cancel on dark surface. */
export const ADMIN_ALERT_CANCEL_CLASS =
  "border-white/15 bg-transparent text-zinc-200 hover:bg-white/10 hover:text-zinc-50";
